import ky from 'ky';

/**
 * Deal Library is a public app that loads GCS-backed assets (e.g. `/deal-library`),
 * not the authenticated Apigee API — so we use a plain ky client.
 */
export const http = ky.create({
  retry: 0,
  headers: {
    'X-OPENX-UI-CLIENT': 'deal-library',
  },
});
